import apiService from '../../../repositories/apiService';

export default {
    getVacationDates(state) {
        return new Promise((resolve, reject) => {
            apiService
                .get('/location/vacationDates')
                .then((response) => {
                    resolve();
                    state.commit('setVacationDates', response.data.data);
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
    storeNewVacationDates(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .post('/location/vacationDates', payload)
                .then((response) => {
                    resolve();
                    state.commit('setVacationDates', response.data.data);
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
    updateVacationDate(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .put(`/location/vacationDates/${payload.vacation_date.id}`, payload)
                .then((response) => {
                    resolve();
                    state.commit('setVacationDates', response.data.data);
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
    deleteVacationDate(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .delete(`/location/vacationDates/${payload.id}`)
                .then((response) => {
                    resolve();
                    state.commit('setVacationDates', response.data.data);
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
};
